import { render, staticRenderFns } from "./OrgCardList.vue?vue&type=template&id=811a79d2"
import script from "./OrgCardList.vue?vue&type=script&lang=js"
export * from "./OrgCardList.vue?vue&type=script&lang=js"
import style0 from "./OrgCardList.vue?vue&type=style&index=0&id=811a79d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports